import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import * as ROUTES from "../../constants/routes";
import LandingPage from "../Landing";
import PasswordForgetPage from "../PasswordForget";
import HomePage from "../Home";

import AddUserPage from "../AddUser";
import ListUsersPage from "../ListUsers";
import UserDetailsPage from "../UserDetails";
import OrdersListPage from "../OrdersList";
import OrderDetailsPage from "../OrderDetails";
import ListProductsPage from "../ListProducts";
import ProductDetailsPage from "../ProductDetails";
import SignInPage from "../SignIn";
import NavBar from "../common/navbar";
import NotFound from "../NotFound/index";
import SignOut from "../SignOut/index";

import { withAuthentication } from "../Session";

const App = () => {
  return (
    <React.Fragment>
      <NavBar />
      <main className="container-fluid">
        <Switch>
          <Route path={ROUTES.SIGN_IN} component={SignInPage} />
          <Route path={ROUTES.PASSWORD_FORGET} component={PasswordForgetPage} />
          <Route path={ROUTES.HOME} component={HomePage} />
          <Route path={ROUTES.LIST_USERS} component={ListUsersPage} />
          <Route path={ROUTES.ADD_USER} component={AddUserPage} />
          <Route path={ROUTES.USER_DETAILS} component={UserDetailsPage} />
          {/* <Route
            path="/user_details/:CompanyName"
            component={UserDetailsPage}
          /> */}
          <Route path={ROUTES.ORDERS_LIST} component={OrdersListPage} />
          <Route path={ROUTES.ORDER_DETAILS} component={OrderDetailsPage} />
          <Route path={ROUTES.LIST_PRODUCTS} component={ListProductsPage} />
          <Route path={ROUTES.PRODUCT_DETAILS} component={ProductDetailsPage} />
          <Route path={ROUTES.SIGN_OUT} component={SignOut} />

          <Route path="/not-found" component={NotFound} />
          <Route exact path={ROUTES.LANDING} component={LandingPage} />
          <Redirect to="not-found" />
        </Switch>
      </main>
    </React.Fragment>
  );
};

export default withAuthentication(App);
